import { mapActions, mapGetters } from 'vuex';
import { translationKeyByCode } from '@/locales/locales';

export default {
  name: 'UserLanguage',
  components: {},
  data() {
    return {
      loading: false
    };
  },
  computed: {
    ...mapGetters(['languages', 'currentLanguage']),
    ...mapGetters({
      user: 'profile/user'
    })
  },
  methods: {
    ...mapActions({
      setUserLocale: 'profile/SET_USER_LOCALE'
    }),
    selectLanguage(code) {
      if (this.loading || this.currentLanguage.code === code) return;

      const translationKey = translationKeyByCode(code);
      if (!translationKey) return;

      this.loading = true;

      this.setUserLocale(translationKey)
        .then(() => {
          this.$setLanguage(code).then(() => {
            window.location.reload();
          });
        })
        .catch((error) => {
          this.loading = false;
          this.$toasted.error(error?.data?.message || this.$t('somethingWentWrong'));
        });
    }
  }
};
